import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApplikasiKreditService from "services/Setup/LoanOrigination/Loan/ApplikasiKreditService";
import CreditAssessmentService from "services/Setup/LoanOrigination/ProsesKredit/CreditAssessment/CreditAssessmentService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingPosGeneral: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  creditAssessmentList: [],
  loanCreditScoring: [],
  phoneverificationItem: [],
  bankverificationItem: [],
  statusRespon: 0,
};

export const getCreditAssessment = createAsyncThunk(
  "CreditAssessment/getCreditAssessment",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.getCreditAssessment(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPhoneverification = createAsyncThunk(
  "CreditAssessment/getPhoneverification",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.getPhoneverification(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  });

export const getBankverification = createAsyncThunk(
  "CreditAssessment/getBankverification",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.getBankverification(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  });

export const posPhoneVerification = createAsyncThunk(
  "CreditAssessment/posPhoneVerification",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.posPhoneVerification(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posBankverification = createAsyncThunk(
  "CreditAssessment/posBankverification",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.posBankverification(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putProceed = createAsyncThunk(
  "CreditAssessment/putProceed",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CreditAssessmentService.putProceed(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);


export const CreditAssessment = createSlice({
  name: "CreditAssessment",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
      state.bankverificationItem = [];
      state.phoneverificationItem = [];
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      //getCreditAssessment
      .addCase(getCreditAssessment.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCreditAssessment.fulfilled, (state, action) => {  
        state.loading = false;
        state.creditAssessmentList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getCreditAssessment.rejected, (state, action) => {
        state.loading = false;
      })
      //getPhoneverification
      .addCase(getPhoneverification.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPhoneverification.fulfilled, (state, action) => {  
        state.loading = false;
        state.phoneverificationItem = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getPhoneverification.rejected, (state, action) => {
        state.loading = false;
      })
      //getBankverification
      .addCase(getBankverification.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getBankverification.fulfilled, (state, action) => {  
        state.loading = false;
        state.bankverificationItem = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getBankverification.rejected, (state, action) => {
        state.loading = false;
      })

      // pos
      .addCase(posPhoneVerification.pending, (state) => {
        state.loading = true;
      })
      .addCase(posPhoneVerification.fulfilled, (state, action) => { 
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posPhoneVerification.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // pos
      .addCase(posBankverification.pending, (state) => {
        state.loading = true;
      })
      .addCase(posBankverification.fulfilled, (state, action) => { 
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posBankverification.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // pos
      .addCase(putProceed.pending, (state) => {
        state.loading = true;
      })
      .addCase(putProceed.fulfilled, (state, action) => { 
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(putProceed.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
} = CreditAssessment.actions;

export default CreditAssessment.reducer;
